/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { QuickCardEditorView } from 'app/scripts/views/card/QuickCardEditorView';
import { getSeparatorClassName } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { CardTitleOnCardFrontTemplate } from 'app/scripts/views/templates/CardTitleOnCardFrontTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const renderName = function () {
  const data = this.model.toJSON();

  data.separatorClassName = getSeparatorClassName(data.name);

  const html = CardTitleOnCardFrontTemplate(data);

  $('.js-card-name', this.$el).html(html);

  return this;
};

const openQuickCardEditor = function (e) {
  if (this.options.quickEditHidden || !this.model.editable()) {
    return;
  }

  stopPropagationAndPreventDefault(e);
  PopOver.hide();
  QuickCardEditorView.open(this);
  Analytics.sendClickedButtonEvent({
    buttonName: 'quickCardEditorButton',
    source: 'cardView',
    containers: this.model?.getAnalyticsContainers(),
  });

  return this;
};

export { renderName };
export { openQuickCardEditor };
